const initialState = {
    currency: ''
}

export default initialState;
